import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Space,
  Modal,
  Select,
  message,
  Typography,
  Input,
} from "antd";
import dataService from "../networks/api/service/dataService";
import GreivanceTable from "../components/GreivanceTable";

function GrievanceList() {
  const [grievances, setGrievances] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch grievance list
  const getGrievanceList = async () => {
    const storedAdminId = localStorage.getItem("adminRoleId");
    let adminId =
      storedAdminId && storedAdminId !== "undefined" && storedAdminId !== "null"
        ? storedAdminId
        : "";

    // Covers an already active session created before the login ID fix.
    if (!adminId) {
      try {
        const token = localStorage
          .getItem("JWTtoken")
          ?.replace(/^Bearer\s+/, "");
        const tokenPayload = token?.split(".")[1];
        if (tokenPayload) {
          const base64Payload = tokenPayload
            .replace(/-/g, "+")
            .replace(/_/g, "/");
          const paddedPayload = base64Payload.padEnd(
            Math.ceil(base64Payload.length / 4) * 4,
            "="
          );
          adminId = JSON.parse(atob(paddedPayload)).id || "";
          if (adminId) localStorage.setItem("adminRoleId", adminId);
        }
      } catch (error) {
        console.error("Unable to read admin ID from login token", error);
      }
    }

    if (!adminId) {
      message.error("Unable to load grievances: admin ID is missing");
      setLoading(false);
      return;
    }

    try {
      const response = await dataService.getGrievancesByAdminId(adminId);
      if (response.code === 200) {
        setGrievances(response.data);
      } else {
        message.error("Failed to fetch grievances");
      }
    } catch (error) {
      message.error("Error fetching grievances");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getGrievanceList();
  }, []);

  const getNewGrievanceList = () => {
    getGrievanceList();
  };

  return (
    <div style={{ padding: "2rem" }}>
      <GreivanceTable
        grievances={grievances}
        getNewGrievanceList={getNewGrievanceList}
        loading={loading}
      />
    </div>
  );
}

export default GrievanceList;
